<template>
  <div>
    <v-container>
      <h1 class="primary--text font-weight-bold pb-4">
        {{
          isEditPropertyType
            ? $t("property.propertyType.updatePropertyType")
            : $t("property.propertyType.newPropertyType")
        }}
      </h1>
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form v-on:submit.prevent="handleSubmit(onSave)" :key="reRender">
          <div
            class="tw-w-full tw-grid tw-gap-x-4 tw-grid-cols-1 lg:tw-grid-cols-2"
          >
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                :name="$t('settings.area.name') + $t('common.en')"
              >
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="`${$t('settings.area.name')} (${$t('common.en')})`"
                  color="secondary"
                  type="text"
                  v-model="propertyTypeModelObj.nameEn"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.area.name") }} ({{ $t("common.en") }})
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                rules="required|arabicText"
                :name="$t('settings.area.name') + $t('common.ar')"
              >
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="`${$t('settings.area.name')} (${$t('common.ar')})`"
                  color="secondary"
                  type="text"
                  v-model="propertyTypeModelObj.nameAr"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.area.name") }} ({{ $t("common.ar") }})
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <!-- <v-col cols="12" sm="6" md="6" class="py-0 pt-6">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-select
                  outlined
                  :error-messages="errors"
                  dense
                  :items="[
                    { text: $t('property.propertyType.perDay'), value: 'PER_DAY'},
                    { text: $t('property.propertyType.perMonth'), value: 'PER_MONTH'}
                  ]"
                  item-text="text"
                  item-value="value"
                  :label="$t('property.unit.rentType')"
                  color="secondary"
                  type="text"
                  v-model="propertyTypeModelObj.rentType"
                >
                <template #label>
                <span class="red--text"><strong>* </strong></span>{{$t('property.unit.rentType')}}
                </template>
                </v-select>
              </ValidationProvider>
            </v-col> -->
          </div>
          <div class=" tw-flex tw-w-full tw-justify-end">
            <!-- <div class="d-flex justify-space-around"> -->
            <!-- <v-btn class="custom-button text-none" @click="onCancel">
                {{ $t("common.cancel") }}
              </v-btn> -->
            <v-btn
              class="white--text"
              color="primary"
              type="submit"
              width="20%"
              :loading="btnLoading"
            >
              {{ isEditPropertyType ? $t("common.update") : $t("common.save") }}
            </v-btn>
            <!-- </div> -->
          </div>
          <v-col v-if="isError != null" cols="12" sm="12"
            ><Alert :message="isError" />
          </v-col>
        </form>
      </ValidationObserver>
    </v-container>
  </div>
</template>
<script>
import "@/core/methods/validation_rules";
import { mapGetters } from "vuex";
import { createPropertyType } from "../../methods/propertyType/create_property_type";
import { updatePropertyType } from "../../methods/propertyType/update_property_type";
export default {
  data() {
    return {
      hasLogo: false,
      btnLoading: false,
      propertyTypeModelObj: {
        nameAr: "",
        nameEn: ""
      },
      isError: null,
      reRender: 0
    };
  },
  components: {
    Alert: () => import("@/core/components/Alert.vue")
  },
  mounted() {
    if (this.isEditPropertyType)
      this.propertyTypeModelObj = this.$format.cloneVariable(
        this.editPropertyType
      );
  },
  watch: {
    isEditPropertyType: {
      handler() {
        if (this.isEditPropertyType) {
          this.propertyTypeModelObj = this.$format.cloneVariable(
            this.editPropertyType
          );
        } else {
          this.propertyTypeModelObj = {
            nameAr: "",
            nameEn: ""
          };
          this.reRender++;
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["isEditPropertyType", "editPropertyType"])
  },
  methods: {
    async onSave() {
      this.btnLoading = true;
      const input = {
        input: this.$format.cloneVariable(this.propertyTypeModelObj)
      };
      if (!this.isEditPropertyType) {
        createPropertyType(input).then(response => {
          if (response.data) {
            this.btnLoading = false;
            this.$root.$emit("refetchPropertyType");
            this.propertyTypeModelObj = {
              nameAr: "",
              nameEn: ""
            };
            this.reRender++;
            this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.saveSuccess"),
              color: "green"
            });
          }
          if (response.graphQLErrors) {
            this.btnLoading = false;
            this.isError = response.graphQLErrors[0].message;
          }
        });
      } else {
        const updateInput = {
          id: input.input._id,
          input: {
            nameEn: input.input.nameEn,
            nameAr: input.input.nameAr
          }
        };
        updatePropertyType(updateInput).then(response => {
          if (response.data) {
            this.btnLoading = false;
            this.$root.$emit("refetchPropertyType");
            this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
            this.$store.commit("IS_EDIT_PROPERTY_TYPE", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.updateSuccess"),
              color: "green"
            });
          }
          if (response.graphQLErrors) {
            this.btnLoading = false;
            this.isError = response.graphQLErrors[0].message;
            setTimeout(() => {
              this.isError = null;
            }, 5000);
          }
        });
      }
    }
    // onCancel() {
    //   this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
    //   this.$store.commit("IS_EDIT_PROPERTY_TYPE", false);
    // },
  }
};
</script>
